"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = warnOnce;

var _once = _interopRequireDefault(require("./once"));

function warnOnce(message) {
  return (0, _once["default"])(function () {
    return console.warn("botframework-webchat: ".concat(message, "."));
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ3YXJuT25jZSIsIm1lc3NhZ2UiLCJvbmNlIiwiY29uc29sZSIsIndhcm4iXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvd2Fybk9uY2UudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IG9uY2UgZnJvbSAnLi9vbmNlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gd2Fybk9uY2UobWVzc2FnZTogc3RyaW5nKTogKCkgPT4gdm9pZCB7XG4gIHJldHVybiBvbmNlKCgpID0+IGNvbnNvbGUud2FybihgYm90ZnJhbWV3b3JrLXdlYmNoYXQ6ICR7bWVzc2FnZX0uYCkpO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFFZSxTQUFTQSxRQUFULENBQWtCQyxPQUFsQixFQUErQztFQUM1RCxPQUFPLElBQUFDLGdCQUFBLEVBQUs7SUFBQSxPQUFNQyxPQUFPLENBQUNDLElBQVIsaUNBQXNDSCxPQUF0QyxPQUFOO0VBQUEsQ0FBTCxDQUFQO0FBQ0QifQ==